import React from 'react';
import { Button, Box } from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

// AG-Grid-style column-filter affordance: pill button per dimension. Funnel icon turns blue and
// fills when the dimension has any active selection; the count badge mirrors the AG Grid header
// chip. Click handler receives the DOM node so the parent can anchor a Popover to it.
export default function FilterButton({ label, count, onClick }) {
	const active = count > 0;
	const Icon = active ? FilterAltIcon : FilterAltOutlinedIcon;

	return (
		<Button
			onClick={(e) => onClick(e.currentTarget)}
			size="small"
			disableRipple
			startIcon={<Icon sx={{ fontSize: 16, color: active ? '#3966D0' : '#7A7A7A' }} />}
			sx={{
				textTransform: 'none',
				fontFamily: 'Poppins',
				fontSize: 13,
				fontWeight: active ? 600 : 400,
				color: active ? '#3966D0' : '#333',
				backgroundColor: active ? '#EBF0FA' : '#fff',
				border: '1px solid',
				borderColor: active ? '#3966D0' : '#E8E8E8',
				borderRadius: '18px',
				px: 1.5,
				py: 0.5,
				minHeight: 32,
				'&:hover': {
					backgroundColor: active ? '#DDE6F7' : '#F7F9FC',
					borderColor: active ? '#3966D0' : '#C8C8C8',
				},
			}}
		>
			{label}
			{active && (
				<Box
					component="span"
					sx={{
						ml: 0.75,
						px: 0.75,
						backgroundColor: '#3966D0',
						color: '#fff',
						borderRadius: '10px',
						fontSize: 11,
						minWidth: 18,
						lineHeight: '16px',
						textAlign: 'center',
						fontWeight: 600,
					}}
				>
					{count}
				</Box>
			)}
		</Button>
	);
}
